function localizedName(value) {
  if (typeof value === "string") return value
  return value?.find((item) => item.language === "ru")?.content || ""
}

export function formatOrders(items, points = []) {
  const pointsById = new Map(points.map((point) => [String(point.id), point]))
  return items.map(({ dashboardOrder: order, dashboardUser: user }) => {
    const point = order.dashboardUserAddresses?.dashboardPoint
    // Адрес может ссылаться на другую точку: используем название только при
    // совпадении с pointId самого заказа. Без названия показываем ID точки из API.
    const matchingPoint = point && (order.pointId == null || String(point.id) === String(order.pointId))
      ? point
      : null
    const directoryPoint = order.pointId == null ? null : pointsById.get(String(order.pointId))
    const goodsTotal = order.totalPriceWithDiscount ?? order.totalPrice

    return {
      key: order.id,
      id: order.id,
      phone: user?.phone,
      innerId: order.innerId,
      outNumber: order.outNumber,
      externalGuid: order.externalGuid,
      isNeedAccept: order.isNeedAccept,
      isPaid: order.isPaid,
      createdAt: order.createdAt,
      orderTotal: goodsTotal == null ? null : Number(goodsTotal) + Number(order.deliveryPrice ?? 0),
      pointName: localizedName(directoryPoint?.shortName) || localizedName(directoryPoint?.name)
        || localizedName(matchingPoint?.name) || localizedName(matchingPoint?.shortName)
        || (order.pointId != null ? `Точка #${order.pointId}` : ""),
    }
  })
}
